import React, { useContext, useEffect } from "react";
import Header_Coral from "./Header_Coral";
import Sidebar_Coral from "./Sidebar_Coral";
import { Outlet } from 'react-router-dom';
function DashboardMain_Coral(props) {


    return (
        <>
            <Header_Coral gloablfilter={props.gloablfilter} />
            <Sidebar_Coral />
            {props.children}
        </>
    );



}

export default DashboardMain_Coral;